export default __webpack_public_path__ + "static/media/logo1.d89793d1.svg";